/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/no-unused-prop-types */
import { useState, MouseEvent } from "react";
import classNames from "classnames";
import { animated, useSpring } from "@react-spring/web";

// Components

// Constants
import { STATUS_NAME } from "constants/transactions";

// Hooks
import useTranslate from "hooks/useTranslate";
import useFormatBalance from "hooks/useFormatBalance";

// Icons
import ArrowIcon from "assets/icons/arrow.svg?react";

// Types
import { TRANSACTION_STATUS, TransactionType } from "types/Transaction";
import TransactionDescription from "../TransactionDescription";

import { PAYMENT_METHODS_CODES } from "../../../constants/paymentMethodsConst";

import "./styles.sass";
import SvgIcon from "../SvgIcon/SvgIcon";

export type TransactionItem = {
  transaction: TransactionType;
};

const TransactionListItemMobile = ({ transaction }: TransactionItem) => {
  const { id, createdAt, updatedAt, method, status, amount, remoteId, type } =
    transaction;
  const [isActive, setIsActive] = useState(true);
  const formatBalance = useFormatBalance();
  const t = useTranslate();
  const isPayment =
    (PAYMENT_METHODS_CODES.REFERRAL ||
      PAYMENT_METHODS_CODES.MANUAL ||
      PAYMENT_METHODS_CODES.BONUS) !== method.code;

  const arrowClass = classNames(
    "TransactionListItemMobile-item-info-block__button",
    {
      arrowDown: !isActive,
      arrowUp: isActive,
    },
  );

  const statusClass = classNames("TransactionListItemMobile__status", {
    success: status === TRANSACTION_STATUS.SUCCESS,
    error:
      status === TRANSACTION_STATUS.ERROR ||
      status === TRANSACTION_STATUS.CANCELED ||
      status === TRANSACTION_STATUS.REJECTED,
    pending:
      status === TRANSACTION_STATUS.PENDING ||
      status === TRANSACTION_STATUS.REQUEST,
  });

  const toggle = (e: MouseEvent): void => {
    e.preventDefault();
    setIsActive(!isActive);
  };

  const getHeight = (active, payment) => {
    if (active) {
      return 0;
    }
    if (payment) {
      return 75;
    }
    return 44;
  };

  const { height, opacity, y } = useSpring({
    from: { height: 0, opacity: 0, y: 0 },
    to: {
      height: getHeight(isActive, isPayment),
      opacity: isActive ? 0 : 1,
    },
  });

  return (
    <div className="TransactionListItemMobile">
      <div className="TransactionListItemMobile-item" onClick={toggle}>
        <div className="TransactionListItemMobile-item-method">
          <SvgIcon
            svgString={method.logo}
            className="TransactionListItemDesktop__logo"
            alt={method.name}
          />
          <div className="TransactionListItemMobile-item-method-block">
            <span className="TransactionListItemMobile-item-method-block__title">
              {method ? t(method.name) : ""}
            </span>
            <span className="TransactionListItemMobile-item-method-block__type">
              {t(type)}
            </span>
          </div>
        </div>
        <div className="TransactionListItemMobile-item-info">
          <div className="TransactionListItemMobile-item-info-block">
            <span className="TransactionListItemMobile-item-info-block__amount">
              {formatBalance(amount)}
            </span>
            <span className={statusClass}>{t(STATUS_NAME[status])}</span>
          </div>
          <ArrowIcon className={arrowClass} />
        </div>
      </div>
      <animated.div
        style={{
          opacity,
          height,
          y,
        }}
      >
        <TransactionDescription
          id={id}
          status={status}
          method={method}
          createdAt={createdAt}
          updatedAt={updatedAt}
          remoteId={remoteId}
          isPayment={isPayment}
        />
      </animated.div>
    </div>
  );
};

export default TransactionListItemMobile;
